import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setPlatformFee, isloading, seterror, resetPlatformFee
} from "../reducers/getPlatformFeeReducer";
import { updateGlobalState } from "../global/slice";

const getPlatformFee = (token: any) => async (dispatch: Dispatch) => {
        const updateState = (key, value) => {
            dispatch(updateGlobalState({ key: key, value: value }));
        };
    dispatch(isloading(true));
    try {
        const result = await api
            .get(
                `/taxes/get-platform-fee/`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                }
            )
        if (result) {
            dispatch(isloading(false));
            if (result.data?.status === 200) {
                if(result?.data?.data?.currency_symbol) {
                    updateState("currency_symbol", result?.data?.data?.currency_symbol);
                }
                dispatch(setPlatformFee(result?.data?.data?.platform_fee_percent));
            }
            else {
                dispatch(seterror(result.data?.status ?? "Something went wrong"));
            }
        }
    }
    catch (error: any) {
        dispatch(seterror(error.response.data.message || "Something went wrong"));
    }
}

export { resetPlatformFee, getPlatformFee };


